import { render, staticRenderFns } from "./TrGamePointsPanel.vue?vue&type=template&id=631fab2f&scoped=true&"
import script from "./TrGamePointsPanel.vue?vue&type=script&lang=js&"
export * from "./TrGamePointsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TrGamePointsPanel.vue?vue&type=style&index=0&id=631fab2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fab2f",
  null
  
)

export default component.exports